import React, { useMemo } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { get, pick, concat, isEmpty } from 'lodash-es'
import clsx from 'clsx'
import { useTbViewStore, useProjectStore } from '@vt/hooks'
import { ErrorFallback, Box } from '@ow/comps'
import Content from '../content'
import ElementRender from './ElementRender'

const showDataTypes = ['list', 'matrix', 'calendar', 'article', 'file', 'map']
const RenderContainerFilter = function ({
  layouts = {},
  afterTransform,
  autoFetchData = true,
  CustomOperateComponent,
  title,
  styles,
}) {
  const footerLayouts = get(layouts, 'footerElement', null)
  const customCompsMap = useProjectStore((state) => state.customCompsMap)
  const { FixedFiltersComponent } = customCompsMap || {}

  const { fixedFilters, loading } = useTbViewStore((state) =>
    pick(state, ['fixedFilters', 'loading'])
  )
  const isShowData = useMemo(() => {
    return (
      layouts.type === 'data' ||
      (layouts.elements &&
        layouts.elements.find((v) => showDataTypes.includes(v.type)))
    )
  }, [layouts])

  const isEmptyConfig = useMemo(() => {
    const configs = concat(
      get(layouts, 'leftElements', []),
      get(layouts, 'rightElements', [])
    )

    if (!configs.length && !layouts.elements) {
      return true
    }
    // 固定筛选的写死了判断，是否可行？
    if (
      configs.length === 1 &&
      configs[0].type === 'fixedFilters' &&
      (!fixedFilters || isEmpty(fixedFilters)) &&
      !FixedFiltersComponent
    ) {
      return true
    }
    return false
  }, [layouts, fixedFilters])

  if (isEmptyConfig) {
    return null
  }

  const elements = get(layouts, 'elements', [])

  const RenderContent = (
    <>
      {!layouts.elements && (
        <div className="relative">
          {loading && (
            <div className="absolute top-0 right-0 w-full h-full flex items-center justify-center z-10 opacity-50 bg-white dark:bg-transparent" />
          )}
          <ElementRender layouts={layouts} />
        </div>
      )}
      {/* 数据展示 */}
      {elements.map((element, index) => {
        if (showDataTypes.includes(element.type)) {
          return (
            <Content
              title={title}
              key={`${element.type}-${index}`}
              afterTransform={afterTransform}
              showType={element.type}
              footerLayouts={footerLayouts}
              autoFetchData={autoFetchData}
              CustomOperateComponent={CustomOperateComponent}
            />
          )
        }
        return null
      })}
    </>
  )
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {layouts.type === 'unboxing' && !isShowData ? (
        RenderContent
      ) : (
        <Box
          key={`${layouts}`}
          className={clsx(
            isShowData && 'flex-1 overflow-hidden md:overflow-y-auto'
          )}
          style={{
            border: 'none',
            ...styles,
          }}
        >
          {RenderContent}
        </Box>
      )}
    </ErrorBoundary>
  )
}

export default RenderContainerFilter
